import NavigationLayout from "../navigation/navigationLayout";
import FoundersLayout from "./founders/foundersLayout";
import VisionNMissionLayout from "./visionNMission/visionNMissionLayout";
import WhoAreWeLayout from "./whoAreWe/whoAreWeLayout";
import FooterLayout from '../footer/footerLayout';
import JoinUsLayout from "./joinUs/joinUsLayout";
import { useEffect } from "react";

const AboutUsLayout = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <NavigationLayout />

            <WhoAreWeLayout />

            <VisionNMissionLayout />

            <FoundersLayout />

            <JoinUsLayout />

            <FooterLayout />
        </>
    );
}

export default AboutUsLayout;